import { useEffect, useRef } from "react";

import { reportUnrecognizedWorkflowLogStatus } from "./api/inbox-adapter";

export type UnrecognizedWorkflowLogStatus = { status: string; workflowLogEntryId: string };

function toStatusKey(item: UnrecognizedWorkflowLogStatus): string {
  return `${item.workflowLogEntryId}:${item.status}`;
}

export function useReportUnrecognizedWorkflowLogStatuses(statuses: UnrecognizedWorkflowLogStatus[]): void {
  const reportedKeys = useRef<Set<string>>(new Set());

  useEffect(() => {
    for (const item of statuses) {
      const key = toStatusKey(item);
      if (reportedKeys.current.has(key)) continue;
      reportedKeys.current.add(key);
      reportUnrecognizedWorkflowLogStatus(item.status, item.workflowLogEntryId);
    }
  }, [statuses]);
}
